import { createReactComponent } from '@tabler/icons-react';

export const IconCustomChartsLines = createReactComponent(
  'outline',
  'customChartsLines',
  'CustomChartsLines',
  [
    [
      'path',
      {
        key: 'customChartsLines-path-1',
        d: 'M3,3v18h18M19.2,4.8H7.2M15.4,12.8h-4.6M13.2,8.8h-4.8M17.4,16.8h-4.2',
      },
    ],
  ]
);
